export interface Transfer {
  id: string;
  type: string;
  title_de: string;
  title_en: string;
  description_de: string;
  description_en: string;
  vehicle_de: string;
  vehicle_en: string;
  max_passengers: number;
  routes: TransferRoute[];
}

export interface TransferRoute {
  from_de: string;
  from_en: string;
  to_de: string;
  to_en: string;
  duration: string;
  price: number;
}

export const transfers: Transfer[] = [
  {
    id: 'airport-hurghada',
    type: 'airport',
    title_de: 'Flughafentransfer Hurghada',
    title_en: 'Hurghada Airport Transfer',
    description_de: 'Privater Flughafentransfer vom Flughafen Hurghada zu Ihrem Hotel. Klimatisiertes Fahrzeug, professioneller Fahrer, pünktlicher Service und direkter Transfer ohne Wartezeiten.',
   description_en: 'Private transfer from Hurghada Airport to your hotel. Air-conditioned vehicle, professional driver, punctual service, and direct transfer with no waiting time.',
    vehicle_de: 'Privat PKW (bis 3 Personen)',
    vehicle_en: 'Private Car (up to 3 people)',
    max_passengers: 3,
    routes: [
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'Hurghada',
  to_en: 'Hurghada',
  duration: '10–15 Min.',
  price: 15
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'Makadi Bay',
  to_en: 'Makadi Bay',
  duration: '30–35 Min.',
  price: 20
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'Sahl Hasheesh',
  to_en: 'Sahl Hasheesh',
  duration: '25–30 Min.',
  price: 20
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'El Gouna',
  to_en: 'El Gouna',
  duration: '40–45 Min.',
  price: 20
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'Soma Bay',
  to_en: 'Soma Bay',
  duration: '45–50 Min.',
  price: 25
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'Safaga',
  to_en: 'Safaga',
  duration: '50–60 Min.',
  price: 35
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'El Quseir',
  to_en: 'El Quseir',
  duration: '100–110 Min.',
  price: 50
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'Port Ghalib',
  to_en: 'Port Ghalib',
  duration: '150–160 Min.',
  price: 70
},
  {
  from_de: 'Flughafen Hurghada',
  from_en: 'Hurghada Airport',
  to_de: 'South Marsa Alam Hotels',
  to_en: 'South Marsa Alam Hotels',
  duration: '180–220 Min.',
  price: 90
},
],
  },
  {
    id: 'airport-marsa-alam',
    type: 'airport',
    title_de: 'Flughafentransfer Marsa Alam',
    title_en: 'Marsa Alam Airport Transfer',
    description_de: 'Privater Flughafentransfer vom Flughafen Marsa Alam zu Ihrem Hotel. Klimatisiertes Fahrzeug, professioneller Fahrer, pünktlicher Service und direkter Transfer ohne Wartezeiten.',
    description_en: 'Private transfer from Marsa Alam Airport to your hotel. Air-conditioned vehicle, professional driver, punctual service, and direct transfer with no waiting time.',
    vehicle_de: 'Privat PKW (bis 3 Personen)',
    vehicle_en: 'Private Car (up to 3 people)',
    max_passengers: 3,
    routes: [
  {
  from_de: 'Flughafen Marsa Alam',
  from_en: 'Marsa Alam Airport',
  to_de: 'Port Ghalib',
  to_en: 'Port Ghalib',
  duration: '10–12 Min.',
  price: 15
},
  {
  from_de: 'Flughafen Marsa Alam',
  from_en: 'Marsa Alam Airport',
  to_de: 'Coraya Bay',
  to_en: 'Coraya Bay',
  duration: '10–15 Min.',
  price: 15
},
  {
  from_de: 'Flughafen Marsa Alam',
  from_en: 'Marsa Alam Airport',
  to_de: 'North Marsa Alam Hotels',
  to_en: 'North Marsa Alam Hotels',
  duration: '65–70 Min.',
  price: 35
},
  {
  from_de: 'Flughafen Marsa Alam',
  from_en: 'Marsa Alam Airport',
  to_de: 'South Marsa Alam Hotels',
  to_en: 'South Marsa Alam Hotels',
  duration: '90–110 Min.',
  price: 50
},
  {
  from_de: 'Flughafen Marsa Alam',
  from_en: 'Marsa Alam Airport',
  to_de: 'Safaga',
  to_en: 'Safaga',
  duration: '120–140 Min.',
    price: 60
  },
],
},
{
  id: 'limousine',
  type: 'limousine',
  title_de: 'Privat Limousine',
    title_en: 'Private Limousine',
    description_de: 'Exklusiver privater Limousinenservice mit professionellem Fahrer. Komfortable, klimatisierte Fahrzeuge für Flughafentransfers und Hoteltransfers in Hurghada, Marsa Alam und entlang der gesamten Red Sea Küste.',
description_en: 'Exclusive private limousine service with a professional driver. Comfortable air-conditioned vehicles for airport and hotel transfers throughout Hurghada, Marsa Alam, and the entire Red Sea coast.',
    vehicle_de: 'Privat Limousine (bis 3 Personen)',
vehicle_en: 'Private Limousine (up to 3 people)',
    max_passengers: 3,
    routes: [
  // Hurghada Airport
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Hurghada',
  to_en: 'Hurghada',
  duration: '10–15 Min.',
  price: 15
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Makadi Bay',
  to_en: 'Makadi Bay',
  duration: '30–35 Min.',
  price: 20
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Sahl Hasheesh',
  to_en: 'Sahl Hasheesh',
  duration: '25–30 Min.',
  price: 20
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'El Gouna',
  to_en: 'El Gouna',
  duration: '40–45 Min.',
  price: 20
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Soma Bay',
  to_en: 'Soma Bay',
  duration: '45–50 Min.',
  price: 25
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Safaga',
  to_en: 'Safaga',
  duration: '50–60 Min.',
  price: 35
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'El Quseir',
  to_en: 'El Quseir',
  duration: '100–110 Min.',
  price: 50
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Port Ghalib',
  to_en: 'Port Ghalib',
  duration: '150–160 Min.',
  price: 70
},
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'South Marsa Alam Hotels',
  to_en: 'South Marsa Alam Hotels',
  duration: '180–220 Min.',
  price: 90
},

  // Marsa Alam Airport
  {
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'Port Ghalib',
  to_en: 'Port Ghalib',
  duration: '10–12 Min.',
  price: 15
},
  {
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'Coraya Bay',
  to_en: 'Coraya Bay',
  duration: '10–15 Min.',
  price: 15
},
  {
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'North Marsa Alam Hotels',
  to_en: 'North Marsa Alam Hotels',
  duration: '65–70 Min.',
  price: 35
},
  {
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'South Marsa Alam Hotels',
  to_en: 'South Marsa Alam Hotels',
  duration: '90–110 Min.',
  price: 50
},
  {
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'Safaga',
  to_en: 'Safaga',
  duration: '120–140 Min.',
  price: 60
},
],
  },
  {
    id: 'minibus',
    type: 'minibus',
    title_de: 'Privat Minibus',
    title_en: 'Private Minibus',
    description_de: 'Unser privater Minibus ist ideal für Familien und Gruppen bis zu 8 Personen. Klimatisiert, geräumig und komfortabel – perfekt für Flughafentransfers und Hoteltransfers entlang der gesamten Red Sea Küste.',
description_en: 'Our private minibus is perfect for families and groups of up to 8 people. Air-conditioned, spacious and comfortable for airport and hotel transfers throughout the Red Sea coast.',
    vehicle_de: 'Privater Minibus (bis 8 Personen)',
vehicle_en: 'Private Minibus (up to 8 people)',
    max_passengers: 8,
    routes: [
  // Hurghada Airport
  {
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Hurghada',
  to_en: 'Hurghada',
  duration: '10–15 Min.',
  price: 20
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Makadi Bay',
  to_en: 'Makadi Bay',
  duration: '30–35 Min.',
  price: 30
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Sahl Hasheesh',
  to_en: 'Sahl Hasheesh',
  duration: '25–30 Min.',
  price: 30
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'El Gouna',
  to_en: 'El Gouna',
  duration: '40–45 Min.',
  price: 30
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Soma Bay',
  to_en: 'Soma Bay',
  duration: '45–50 Min.',
  price: 35
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Safaga',
  to_en: 'Safaga',
  duration: '50–60 Min.',
  price: 40
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'El Quseir',
  to_en: 'El Quseir',
  duration: '100–110 Min.',
  price: 65
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'Port Ghalib',
  to_en: 'Port Ghalib',
  duration: '150–160 Min.',
  price: 90
},
{
  from_de: 'Hurghada Airport',
  from_en: 'Hurghada Airport',
  to_de: 'South Marsa Alam Hotels',
  to_en: 'South Marsa Alam Hotels',
  duration: '180–220 Min.',
  price: 110
},

// Marsa Alam Airport

{
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'Port Ghalib',
  to_en: 'Port Ghalib',
  duration: '10–12 Min.',
  price: 20
},
{
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'Coraya Bay',
  to_en: 'Coraya Bay',
  duration: '10–15 Min.',
  price: 20
},
{
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'North Marsa Alam Hotels',
  to_en: 'North Marsa Alam Hotels',
  duration: '65–70 Min.',
  price: 40
},
{
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'South Marsa Alam Hotels',
  to_en: 'South Marsa Alam Hotels',
  duration: '90–110 Min.',
  price: 65
},
{
  from_de: 'Marsa Alam Airport',
  from_en: 'Marsa Alam Airport',
  to_de: 'Safaga',
  to_en: 'Safaga',
  duration: '120–140 Min.',
  price: 75
},
],
  
  },
];

export const transferDestinations = [
    'Hurghada',
  'El Gouna',
  'Makadi Bay',
  'Sahl Hasheesh',
  'Soma Bay',
  'Safaga',
  'El Quseir',
  'Port Ghalib',
  'Coraya Bay',
  'North Marsa Alam Hotels',
  'South Marsa Alam Hotels',
];